import {AfterViewInit, Component, ElementRef, inject, input, OnInit, ViewChild} from '@angular/core';
import {ECharts, EChartsOption, init} from 'echarts';
import {Router} from "@angular/router";

@Component({
  selector: 'donut-chart',
  templateUrl: './donut-chart.component.html',
  styleUrls: ['./donut-chart.component.css'],
  standalone: false
})
export class DonutChartComponent implements OnInit, AfterViewInit {
  data = input.required<any>();
  entityName = input<string>();
  @ViewChild('chartContainer') chartContainer!: ElementRef;
  chartInstance: ECharts | undefined;

  private readonly router = inject(Router);

  ngAfterViewInit(): void {
    this.chartInstance = init(this.chartContainer.nativeElement);
    this.chartInstance.setOption(this.options);
    this.chartInstance.on('click', (params: any) => {
      this.redirect(params.data);
    });
  }

  redirect(params: any) {
    if (this.entityName() == 'Job') {
      const url = this.router.serializeUrl(
        this.router.createUrlTree(['/jobs'], {queryParams: {status: params.name.replaceAll(' ', '_').toLowerCase()}})
      );
      window.open(url, '_blank');
    }
    if (this.entityName() == 'Service Request') {
      //TODO ADD PERMISSION CHECK
      const url = this.router.serializeUrl(
        this.router.createUrlTree(['/service-requests'], {queryParams: {status: params.name.replaceAll(' ', '_').toLowerCase()}})
      );
      window.open(url, '_blank');
    }
    if (this.entityName() == 'Asset') {
      const url = this.router.serializeUrl(
        this.router.createUrlTree(['/dashboard'], {queryParams: {status: params.name.replaceAll(' ', '_').toLowerCase()}})
      );
      window.open(url, '_self');
    }
  }

  options: EChartsOption = {
    tooltip: {
      trigger: 'item',
      formatter: '<span class="text-gray-600 tracking-normal">{a} <br/>{b} : {c} ({d}%)</span>'
    },
    series: []
  };

  ngOnInit(): void {
    this.options.series = [
      {
        animationTypeUpdate: 'transition',
        animationType: 'scale',
        animation: true,
        animationDuration: 1000,
        data: this.data(),
        name: this.entityName(),
        type: 'pie',
        radius: ['40%', '70%'],
        avoidLabelOverlap: false,
        itemStyle: {
          color: (params) => {
            const colors = ['#FF5733', '#33FF57', '#3357FF', '#F333FF', '#33FFF3']; // Define your color array
            const serviceRequestStatusToColorMapping: { [key: string]: string } = {
              'New': '#9B59B6',
              'In Progress': '#DAA520',
              'Completed': '#3498DB',
              'Canceled': '#DC143C'
            };
            const assetStatusToColorMapping: { [key: string]: string } = {
              'Current': '#27AE60',
              'Upcoming': '#DAA520',
              'Past Due': '#DC143C'
            };
            const jobStatusToColorMapping: { [key: string]: string } = {
              'Received': '#9B59B6',
              'Needs Evaluation': '#D35400',
              'Ready to Quote': '#E67E22',
              'Awaiting approval': '#F1C40F',
              'Quote Approved': '#27AE60',
              'Awaiting Parts': '#DAA520',
              'Work in Progress': '#FFDB58',
              'In-Cosmetics': '#FFEF00',
              'Quote Denied': '#DC143C',
              'Ready for Shipping': '#ED7D31',
              'Shipped': '#4472C4',
              'Canceled': '#DC143C'
            };
            if (this.entityName() == 'Job') {
              return jobStatusToColorMapping[params.name];
            }
            if (this.entityName() == 'Asset') {
              return assetStatusToColorMapping[params.name];
            }
            if (this.entityName() == 'Service Request') {
              return serviceRequestStatusToColorMapping[params.name];
            }
            return colors[params.dataIndex % colors.length]; // Cycle through colors based on dataIndex
          },
          borderRadius: 2,
          borderColor: '#fff',
          borderWidth: 2
        },

        label: {
          show: false,
          position: 'center'
        },
        emphasis: {
          label: {
            show: false,
            fontSize: 5,
            fontWeight: 'bold'
          }
        },
        labelLine: {
          show: false
        },
      },
    ];
  }
}
